
import React from 'react'
import {AlertTriangle, Shield, FileText, Mail} from 'lucide-react'

const Disclaimer = () => {
  return (
    <div className="min-h-screen py-20 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <AlertTriangle className="h-16 w-16 text-primary-teal mx-auto mb-6" />
          <h1 className="text-4xl md:text-5xl font-bold text-primary-navy mb-6">
            Disclaimer
          </h1>
          <p className="text-xl text-primary-slate">
            Important legal information about using Nursing Hive
          </p>
        </div>

        <div className="bg-white rounded-2xl p-8 md:p-12 border border-gray-200">
          <div className="space-y-8">
            
            <div className="bg-primary-light p-6 rounded-lg">
              <p className="text-primary-slate leading-relaxed">
                Nursing Hive is an informational platform connecting nursing professionals with global career opportunities. 
                By using this platform, you agree to the following:
              </p>
            </div>

            {/* Legal sections */}
            <div className="space-y-8">
              
              <section>
                <h2 className="text-2xl font-bold text-primary-navy mb-4 flex items-center">
                  <FileText className="h-6 w-6 text-primary-teal mr-3" />
                  1. NOT LEGAL ADVICE
                </h2>
                <div className="text-primary-slate space-y-3">
                  <p>Nursing Hive provides educational guides and career pathway information only. We are not lawyers, immigration consultants, or licensing authorities.</p>
                  <p><strong>Always consult official sources:</strong></p>
                  <ul className="list-disc list-inside ml-4 space-y-1">
                    <li>Your national nursing council</li>
                    <li>Official government immigration websites</li>
                    <li>Licensed immigration consultants</li>
                    <li>Licensing boards in your destination country</li>
                  </ul>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-primary-navy mb-4">2. NO GUARANTEE OF EMPLOYMENT</h2>
                <div className="text-primary-slate space-y-3">
                  <p>Nursing Hive connects nurses with recruiters but cannot guarantee job placement, visa sponsorship, or employment.</p>
                  <p>Job availability depends on qualifications, market conditions, and recruiter decisions.</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-primary-navy mb-4">3. CREDENTIAL VERIFICATION</h2>
                <div className="text-primary-slate space-y-3">
                  <p>You are responsible for ensuring your credentials (education, license, English test scores) are accurate and valid.</p>
                  <p>Nursing Hive does not verify credentials on your behalf.</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-primary-navy mb-4">4. THIRD-PARTY RECRUITERS</h2>
                <div className="text-primary-slate space-y-3">
                  <p>We connect you with external agencies but are not responsible for their hiring practices, contract terms, or employment conditions.</p>
                  <p>Always verify recruiter legitimacy and read contracts carefully.</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-primary-navy mb-4 flex items-center">
                  <Shield className="h-6 w-6 text-primary-teal mr-3" />
                  5. DATA PRIVACY
                </h2>
                <div className="text-primary-slate space-y-3">
                  <p>Your profile remains private until you opt in to share with recruiters.</p>
                  <p>However, the internet carries inherent risks, and we are not liable for unauthorized access beyond our reasonable control.</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-primary-navy mb-4">6. NO MEDICAL ADVICE</h2>
                <p className="text-primary-slate">Content on Nursing Hive is educational only. We do not provide clinical or healthcare advice.</p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-primary-navy mb-4">7. COUNTRY-SPECIFIC REGULATIONS</h2>
                <div className="text-primary-slate space-y-3">
                  <p>Nursing regulations and visa requirements vary and change frequently.</p>
                  <p>Always verify with official sources before applying.</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-primary-navy mb-4">8. LIMITATION OF LIABILITY</h2>
                <div className="text-primary-slate space-y-3">
                  <p>Nursing Hive is provided "as-is" without warranties.</p>
                  <p>We are not liable for job placement failures, visa denials, exam outcomes, or financial losses.</p>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-primary-navy mb-4">9. USER RESPONSIBILITY</h2>
                <p className="text-primary-slate">By registering, you confirm that all information you provide is truthful, accurate, and verifiable.</p>
              </section>

              <section>
                <h2 className="text-2xl font-bold text-primary-navy mb-4">10. CHANGES TO DISCLAIMER</h2>
                <p className="text-primary-slate">We may update this page without notice. Continued use implies acceptance.</p>
              </section>

            </div>

            {/* Contact section */}
            <section className="bg-primary-light p-8 rounded-lg">
              <div className="flex items-center space-x-3 mb-4">
                <Mail className="h-6 w-6 text-primary-teal" />
                <h2 className="text-2xl font-bold text-primary-navy">Questions?</h2>
              </div>
              <p className="text-primary-slate mb-4">
                Contact us at <a href="mailto:hello@nursinghive.com" className="text-primary-teal hover:underline font-semibold">hello@nursinghive.com</a> or visit our <a href="/contact" className="text-primary-teal hover:underline font-semibold">Contact</a> page.
              </p>
            </section>

          </div>

          <div className="mt-12 pt-8 border-t border-gray-200 text-center text-sm text-primary-slate">
            <p>Last updated: November 2025</p>
            <p className="mt-2">© 2025 Nursing Hive — Ethical international nursing mobility.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Disclaimer
